enum ToursTableAccessor {
  Date = 'date',
  Property = 'property',
  Actions = 'actions',
  Status = 'status',
}

export { ToursTableAccessor };
